import { Turnstile } from '@marsidev/react-turnstile';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield } from 'lucide-react';

interface TurnstileBoxProps {
  show: boolean;
  onVerify: (token: string) => void;
  siteKey?: string;
}

export function TurnstileBox({ show, onVerify, siteKey }: TurnstileBoxProps) {
  const finalSiteKey = siteKey || import.meta.env.VITE_TURNSTILE_SITE_KEY;

  if (!finalSiteKey) {
     // We do not fallback to '1x00000000000000000000AA' as it is a demo key.
     // Better to fail loudly than think security works when it doesn't.
     throw new Error("Missing Turnstile site key (VITE_TURNSTILE_SITE_KEY)");
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="space-y-4 overflow-hidden"
        >
          <div className="flex flex-col items-center justify-center p-4 rounded-xl bg-cyan-500/5 border border-cyan-500/10">
            <div className="flex items-center gap-2 mb-3 text-cyan-400">
              <Shield className="w-4 h-4" />
              <span className="text-xs font-bold uppercase tracking-wider">Security Verification</span>
            </div>
            
            <Turnstile
              siteKey={finalSiteKey}
              onSuccess={(token) => onVerify(token)}
              options={{
                theme: 'dark',
                size: 'normal',
              }}
            />
            
            <p className="mt-3 text-[10px] text-zinc-500 text-center max-w-[200px]">
              Additional security required to verify this request is authentic.
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
